import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useTimeZones = (config) => {
  return useQuery({
    ...config,
    queryKey: "time-zones",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/localization/timezones`,
        signal,
      }),
  });
};
